// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { createAsyncThunk } from '@reduxjs/toolkit';
import { type WatchListPosition } from '@shared/data-access/interfaces/redux/my-research-state';
import { assetsApi } from '@shared/data-access/api/ai/assets-api';
import { watchlistApi } from '@shared/data-access/api/engine/watchlist-api';

export const addWatchListPosition = createAsyncThunk(
  'myResearch/addWatchListPosition',
  /* istanbul ignore next */ async (
    params: { ticker: string; assetType: string },
    { dispatch },
  ) => {
    const assetInfoResp = await dispatch(
      assetsApi.endpoints.assetsInfo.initiate({
        params: { detail: true },
        payload: [params.ticker],
        assetType: params.assetType,
      }),
    ).unwrap();

    const assetInfo = assetInfoResp[0] as any;

    /* istanbul ignore next */
    const item = {
      ticker: assetInfo.ticker,
      name: assetInfo.name,
      asset_type: params.assetType,
      isin: assetInfo.isin || '-',
    };

    const [addedItem] = await dispatch(
      watchlistApi.endpoints.addToWatchlist.initiate([item]),
    ).unwrap();

    return {
      ...addedItem,
      pb: assetInfo.pb,
      pe: assetInfo.pe,
      market_cap: assetInfo?.market_cap,
      yield: assetInfo?.dividend_yield,
      url_logo: assetInfo?.url_logo,
      ytd_return: assetInfo.ytd_return,
      y1_return: assetInfo.y1_return,
      y3_return: assetInfo.y3_return,
      y5_return: assetInfo.y5_return,
      y10_return: assetInfo.y10_return,
      y3_vol: assetInfo.y3_vol,
      y5_vol: assetInfo.y5_vol,
      y10_vol: assetInfo.y10_vol,
      max_draw_down: assetInfo.max_draw_down,
      last_update: assetInfo.last_update,
      asset_class:
        addedItem?.asset_type === 'stock' ? 'Equity' : assetInfo.asset_class,
      currency: assetInfo.currency,
      dfi_url: assetInfo?.dfi_url,
    } as WatchListPosition;
  },
);

export const removeWatchListPosition = createAsyncThunk(
  'myResearch/removeWatchListPosition',
  /* istanbul ignore next */ async (params: { ticker: string }, { dispatch }) => {
    await dispatch(
      watchlistApi.endpoints.deleteFromWatchlist.initiate({
        ticker: params.ticker,
      }),
    ).unwrap();

    return params.ticker;
  },
);
